import { type ILayout } from './_Models';
import { DefaultConfig } from './_LayoutConfig';

/**
 * Layout configuration for Community users.
 * Uses a light-header layout with no sidebar, providing a clean and concise UI
 * appropriate for users with minimal navigation needs.
 */

export const CommunityLayoutConfig: ILayout = {
  ...DefaultConfig,
  layoutType: 'light-header',
  app: {
    ...DefaultConfig.app,
    sidebar: {
      ...DefaultConfig.app?.sidebar,
      display: false,
    },
    pageTitle: {
      ...DefaultConfig.app?.pageTitle,
      display: true,
      direction: 'column',
      class: 'my-3',
    },
    header: {
      ...DefaultConfig.app?.header,
      display: true,
      default: {
        ...DefaultConfig.app?.header?.default,
        content: 'menu',
        fixed: {
          desktop: true,
          mobile: true,
        },
        menu: {
          display: true,
          iconType: 'svg',
        },
      },
    },
    toolbar: {
      ...DefaultConfig.app?.toolbar,
      display: true,
      layout: 'classic',
      container: 'fluid',
      fixed: {
        desktop: true,
        mobile: true,
      },
      daterangepickerButton: false,
      secondaryButton: false,
      primaryButton: false,
      filterButton: false,
    },
  },
};
